import React from 'react';
import {
  Grid,
  Typography,
  Card,
  CardContent,
  Avatar,
  Box,
} from '@mui/material';

const CustomerDetails = ({ order }) => {
  const customer = order?.customer || {};

  return (
    <Card sx={{ mt: 2 }}>
      <CardContent>
        <Typography variant="h6" sx={{ mb: 1 }}>Customer Information</Typography>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Avatar />
              <Typography variant="body2" sx={{ ml: 1 }}>{customer.name || '—'}</Typography>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body2">
              <Typography component="span" variant="body2" fontWeight={600}>
                Email:
              </Typography>{' '}
              {customer.email || '—'}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body2">
              <Typography component="span" variant="body2" fontWeight={600}>
                Phone:
              </Typography>{' '}
              {customer.phoneNo || '—'}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default CustomerDetails;
